const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ReportPage/hooks.ts';
import { Report, WorkItem } from '@cistec/common_web/defs/kisim';
import { usePDFReadConfirmation, useReportsToSign, useSignedReports } from 'App/store/documents';
import { useFeatureFlags } from 'App/store/featureFlags';

export const useReportInfo = (report: Report) => {
    const { SENDER, REPORTNR } = report;
    const findSignatureWorkItemForReport = (workItem: WorkItem) => {
        const Report = workItem.CONTENT.Report!;
        return Report.SENDER === SENDER && Report.REPORTNR === REPORTNR;
    };

    const { data: featureFlags } = useFeatureFlags();

    const { data: reportsToSign } = useReportsToSign();
    const reportToSignInfo = reportsToSign && reportsToSign.find(findSignatureWorkItemForReport);
    const needsSignature = !!reportToSignInfo;

    const { data: signedReports } = useSignedReports();
    const signedReportInfo = signedReports && signedReports.find(findSignatureWorkItemForReport);
    const hasSignature = !!signedReportInfo;

    const imageInfo = (() => {
        if (reportToSignInfo || signedReportInfo) {
            const PDF = (reportToSignInfo || signedReportInfo).CONTENT.PDF;
            return { sender: PDF.SENDER as string, code: PDF.ICODE as string };
        }
        return { sender: undefined, code: undefined };
    })();

    const { showDocumentReadConf: allowReadConfirmation } = featureFlags.reports;

    const { data: documentReadConfirmation } = usePDFReadConfirmation(REPORTNR);
    const isDocumentRead = allowReadConfirmation && !!documentReadConfirmation;
    const needsToBeRead = allowReadConfirmation && !(needsSignature || hasSignature) && !isDocumentRead;

    return {
        hasSignature,
        isDocumentRead,
        needsSignature,
        needsToBeRead,
        imageInfo,
        reportToSignInfo,
        signedReportInfo,
    };
};
